"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.USER_TYPE = void 0;
/**
 * User type (for log)
 */
var USER_TYPE;
(function (USER_TYPE) {
    USER_TYPE["WEB"] = "WEB";
    USER_TYPE["MOBILE"] = "MOBILE";
    USER_TYPE["CUSTOMER"] = "CUSTOMER";
    USER_TYPE["SYSTEM"] = "SYSTEM";
})(USER_TYPE || (exports.USER_TYPE = USER_TYPE = {}));
